angular.module('bbl.services.toast', [])
	.factory('Toast', ['$rootScope', '$compile', '$timeout', 'modals', ToastServiceFactory]);

function ToastServiceFactory($rootScope, $compile, $timeout, modals) {
	var $body = angular.element('body'),
		$toastsWrapper = angular.element('<div class="toasts-wrapper">'),
    toasts = {},
    history = [];

	$body.append($toastsWrapper);

	function addToast(type, message, opts) {
		var params = opts || {},
			$scope = params.scope;

		if(!$scope) {
			$scope = $rootScope.$new();
			$scope.message = message;
			angular.extend($scope, params.data);
		}

		$scope.toastType = $scope.toastType || ($scope.toastType = type);
    $scope.persistent = params.persistent;
		$scope.snoozable = params.snoozable;

		var toast = $compile(''+
			'<div class="toast-msg toast-msg-{{toastType}}" ng-class="{persistent: persistent}">'+
				'<span class="toast-body">'+message+'</span>'+
        '<span class="actions">'+
          '<a class="close" ng-click="removeToast()" href="javascript:;">'+
            '<span class="fa fa-times"></span>'+
          '</a>'+
          '<a class="snooze" ng-click="snooze()" href="javascript:;" title="Mute Notifications" ng-if="snoozable">'+
            '<span class="fa fa-clock-o"></span>'+
          '</a>'+
        '</span>'+
			'</div>'
		)($scope);

		if(!$scope.$$phase){
			$scope.$apply();
		}

		$toastsWrapper.append(toast);

		var removeToast = $scope.removeToast = function removeToast() {
			toast.remove();
			$scope.$destroy();

			if(!params.persistent) {
				delete toasts[toast.id];
			}
		};

    $scope.snooze = function snoozeToasts() {
      modals.snoozeNotifications().modal();
    };

		if(!params.persistent) {
			$timeout(removeToast, params.duration || 5000);
		}

		if(params.uid && toasts[params.uid]) {
			toasts[params.uid].remove();
		}

    var uid = params.uid || Date.now();

    if (history.length > 3) {
      history.splice(0, history.length - 3).forEach(function(id) {
        toasts[id].remove();
      });
    }

    history.push(uid);

		return (toasts[uid] = {
      uid: uid,
      persistent: params.persistent,
			update: $scope.$apply.bind($scope),
			remove: removeToast,
			onRemove: $scope.$on.bind($scope, '$destroy'),
		});
	}

  function snoozeNotifications(end, option) {
    if(end === undefined) {
      return JSON.parse(localStorage.getItem('x-toast-notif') || '{}');
    }

    localStorage.setItem('x-toast-notif', JSON.stringify({end: end+'', option: option}));
  }

	return {
		notify: addToast.bind(0, 'info'),
		error: addToast.bind(0, 'danger'),

    snooze: snoozeNotifications,
    muted: function isMuted() {
      var settings = snoozeNotifications();
      return settings.end === 'Infinity' || Date.now() < +settings.end;
    },
	};
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/toast-service.js
 ** module id = 160
 ** module chunks = 0
 **/